import * as React from 'react';

export function AppointmentsUpsell(
  props: React.HTMLAttributes<SVGSVGElement> & { label: string },
) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={props.label}
      style={{ marginLeft: '-2px' }}
    >
      <path
        d="M4 11H24V22C24 23.1046 23.1046 24 22 24H6C4.89543 24 4 23.1046 4 22V11Z"
        fill="url(#paint0_linear_844_23020)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 5.5C8 4.67157 8.67157 4 9.5 4C10.3284 4 11 4.67157 11 5.5V6H17V5.5C17 4.67157 17.6716 4 18.5 4C19.3284 4 20 4.67157 20 5.5V6H22C23.1046 6 24 6.89543 24 8V11H4V8C4 6.89543 4.89543 6 6 6H8V5.5Z"
        fill="url(#paint1_linear_844_23020)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_844_23020"
          x1="14"
          y1="11"
          x2="14"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.4" />
          <stop offset="1" stopColor="white" stopOpacity="0.8" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_844_23020"
          x1="14"
          y1="4"
          x2="14"
          y2="11"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.31" />
          <stop offset="1" stopColor="white" stopOpacity="0.8" />
        </linearGradient>
      </defs>
    </svg>
  );
}
